module.exports = __webpack_public_path__ + "img/BlinkArt_Sword1_Gold.e709aaa3.png";